import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=3d6e2bd2&scoped=true&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"
import style0 from "./Address.vue?vue&type=style&index=0&id=3d6e2bd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../东方蚂蚁/e-shop/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e2bd2",
  null
  
)

export default component.exports